import { VueQueryPlugin } from '@tanstack/vue-query'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import { router } from './router'
import { vueQueryPluginOptions } from './shared/api'

// Tokeny sa importujú tu (cez main.css), aby platili skôr, než sa vykreslí
// prvý komponent — inak by prvý snímok blikol nenaštýlovaný.
import './assets/styles/main.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(VueQueryPlugin, vueQueryPluginOptions)

app.mount('#app')
